import axios from "../utils/axios";

export const getWebsiteSettings = async () => {
    const { data } = await axios.get("/settings");
    return data;
};
